import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    text: {
        id: "cookie.text",
    },
    okay: {
        id: "cookie.okay",
    },
});

export default messages;
